// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xdlz","rootMobile":"styles_rootMobile__SLkv4"};